import { DealAboutCard } from '@/components/DealAboutCard';
import { DealFinePrint } from '@/components/DealFinePrint';
import { DealProgressSection } from '@/components/DealProgressSection';
import { DealWhatYouGetCard } from '@/components/DealWhatYouGetCard';
import { FaqCard } from '@/components/FaqCard';
import { HowItWorksSteps } from '@/components/HowItWorksSteps';
import type { Action, Deal, DealCta, DealStep } from '@/types/deal';

export type RewardDealBodyProps = {
  deal: Deal;
  action?: Action;
  onCtaPress: (step: DealStep, cta?: DealCta) => void;
  ctaLoading: boolean;
  ctaError: string | null;
  settled: boolean;
};

/**
 * A reward deal's page below the hero: about → reward → how it works →
 * steps → FAQ → fine print. Every card is server copy and renders nothing
 * for a deal that doesn't author it.
 */
export function RewardDealBody({ deal, action, onCtaPress, ctaLoading, ctaError, settled }: RewardDealBodyProps) {
  const copy = deal.marketing_copy;
  return (
    <>
      {deal.description ? <DealAboutCard text={deal.description} testID="deal-about" /> : null}
      <DealWhatYouGetCard lines={copy?.hero_body_lines} testID="deal-what-you-get" />
      {copy?.how_it_works?.length ? (
        <HowItWorksSteps title="How it works" steps={copy.how_it_works} testID="deal-how-it-works" />
      ) : null}

      <DealProgressSection
        deal={deal}
        action={action}
        onCtaPress={onCtaPress}
        ctaLoading={ctaLoading}
        ctaError={ctaError}
        settled={settled}
      />

      {/* Deal FAQ, server-authored per deal (marketing_copy.faq). The same
          questions the Refer screen hands ambassadors to copy/paste; here
          they answer the person doing the deal. Renders nothing for a deal
          with none. */}
      <FaqCard title="FAQ" items={copy?.faq} testID="deal-faq" />

      <DealFinePrint terms={deal.terms} disclosure={copy?.compliance_disclosure} testID="deal-fine-print" />
    </>
  );
}
